import { effect, Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LayoutStateService {
  // Determines if the layout is currently on a mobile screen
  readonly isMobile = signal<boolean>(window.innerWidth < 992);
  readonly isTablet = signal<boolean>(window.innerWidth < 1200);

  // Sidebar state (open or closed)
  readonly sidebarOpen = signal<boolean>(!this.isMobile());

  constructor() {
    // Watch for window resize events
    window.addEventListener('resize', () => {
      const mobile = window.innerWidth < 992;
      const wasMobile = this.isMobile();

      this.isMobile.set(mobile);

      const tablet = window.innerWidth < 1200;
      this.isTablet.set(tablet);

      // Close the sidebar when switching to mobile
      if (mobile && !wasMobile) {
        this.sidebarOpen.set(false);
      }

      // Reopen the sidebar when switching back to desktop
      if (!mobile && wasMobile) {
        this.sidebarOpen.set(true);
      }
    });

    // Close sidebar on Escape when open on mobile
    window.addEventListener('keydown', (event: KeyboardEvent) => {
      if (event.key === 'Escape' && this.isMobile() && this.sidebarOpen()) {
        this.sidebarOpen.set(false);
      }
    });

    // Lock body scroll while the mobile drawer is open to avoid double scroll
    effect(() => {
      const shouldLock = this.isMobile() && this.sidebarOpen();
      document.body.style.overflow = shouldLock ? 'hidden' : '';
    });
  }

  // Control methods
  toggleSidebar(): void {
    this.sidebarOpen.set(!this.sidebarOpen());
  }

  closeSidebar(): void {
    this.sidebarOpen.set(false);
  }
}
